import type { Labeled } from '@/lib/tone'

export const INVITE_STATUS: Record<string, Labeled> = {
  pending: { label: 'Pendente', tone: 'warning' },
  accepted: { label: 'Aceito', tone: 'success' },
  rejected: { label: 'Recusado', tone: 'danger' },
  expired: { label: 'Expirado', tone: 'neutral' }
}

export const inviteStatus = (status?: string | null): Labeled => INVITE_STATUS[status ?? 'pending'] ?? INVITE_STATUS.pending
